import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import API from 'services/api';
import { MainContext } from 'components/layout/MainContext';
import { useIsSessionOpen } from 'hooks/useIsSessionOpen';

export const useCurrentUser = () => {
    const { closeSession } = useContext(MainContext);
    const isSessionOpen = useIsSessionOpen();

    const loadData = async () => {
        if (!isSessionOpen) return;

        try {
            const response = await API.getCurrentUser();
            return response.data;
        } catch (error: any) {
            if (error.response.status === 403) {
                closeSession();
            }
        }
    };

    return useQuery({
        queryKey: ['currentUser'],
        queryFn: loadData,
    });
};
